import axios from "axios";
import rutas from '@/assets/utils/rutas.json';
import dataProvincias from '@/shared/constants/provincias.json';


const getNacionalidades = async () => {

  const query = `
    query {
      allNacionalidades {
        id
        descripcion
      }
    }
  `;


  try{
    
    const response = await axios.post( rutas.axios + 'api', { query } );
    const data = response.data.data.allNacionalidades;

    const dataMap = data.map( item => ({
      value: item.id,
      text: item.descripcion
    }));

    return dataMap;

  }catch(error){
    console.error('Error en getNacionalidades', error);
    return null;
  }
}



const getNivelesEducacion = async () => {

  const query = `
    query {
      allNiveleducacion {
        id
        descripcion
      }
    }
  `;

  try{
    const response = await axios.post(rutas.axios + 'api', { query });

    const data =  response.data.data.allNiveleducacion;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('niveles educacion', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error en getNivelesEducacion', error);
  }
}


const getProfesiones = async () => {

  const query = `
    query {
      allOcupacion {
        id
        descripcion
      }
    }
  `;

  try{

    const response = await axios.post(rutas.axios + 'api', { query });
    const data =  response.data.data.allOcupacion;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('profesiones', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error en obtener las profesiones', error);
    return null;
  }
}


const createProfesion = async (descripcion) => {

  const query = `
    mutation CrearOcupacion(
      $descripcion: String!
    ) {
      crearOcupacion(
        descripcion: $descripcion
      ) {
        ocupacion {
          id
          token
        }
      }
    }
  `;

  const variables = {
    descripcion
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    if(response.status !== 200) return null;
    console.log('response profesion', response);

    const response2 = response.data.data.crearOcupacion;
    
    const data = response2.ocupacion;

    return data;
  }catch(error){
    console.error('Error al registrar una nueva profesion', error);
    return null;
  }
}


const createNacionalidad = async ( descripcion ) => {

  const query = `
    mutation CrearNacionalidad($descripcion: String!) {
      crearNacionalidad(descripcion: $descripcion) {
        nacionalidad {
          id
          token
        }
        message
        status
      }
    }
  `;

  const variables = {
    descripcion
  };

  try{
    const response = await axios.post(rutas.axios + 'api', { query, variables });
    console.log('response nacionalidad', response);
    if(response.status !== 200) return null;

    const response2 = response.data.data.crearNacionalidad;
    
    const data = response2.nacionalidad;

    return data;
  }catch(error){
    console.error('Error al registrar una nueva profesion', error);
    return null;
  }
}




const getNacionalidadesEtnicas = async () => {

  const query = `
    query {
      allNacionalidadetnia {
        id
        descripcion
      }
    }
  `;

  try{

    const response = await axios.post(rutas.axios + 'api', { query });
    const data = response.data.data.allNacionalidadetnia;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('nacionalidades etnicas', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error al obtener las nacionalidades etnicas', error);
    return error;
  }
}


const getPueblosKichwa = async () => {

  const query = `
    query {
      allPueblokichwa {
        id
        descripcion
      }
    }
  `;

  try{
    const response = await axios.post(rutas.axios + 'api', { query });

    const data = response.data.data.allPueblokichwa;
    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('pueblos kichwa', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error en obtener pueblos kichwa', error);
    return null;
  }
}


const getPaises = async () => {
  
  const query = `
    query {
      allPais {
        id
        token
        descripcion
      }
    }
  `;

  try{
    const response = await axios.post(rutas.axios + 'api', { query });
    const data = response.data.data.allPais;

    const dataMap = data.map(item => ({
      value : item.id,
      text  : item.descripcion,
      token : item.token
    }));

    // console.log('paises', dataMap);
    return dataMap;
  }catch(error){
    console.error('Error en obtener paises', error);
    return null;
  }
}


const getProvinciasByPais = async ( paisId ) => {

  if( !paisId ) return [];

  const query = `
    query {
      allProvincia(idPais: "${paisId}") {
        id
        descripcion
      }
    }
  `;

  try{

    const response = await axios.post(rutas.axios + 'api', { query });
    const data = response.data.data.allProvincia;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('provincias', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error en obtener provincias por pais', error);
    return null;
  }
}


const getCantonesByProvincia = async ( provinciaId ) => {

  if( !provinciaId ) return [];
  
  const query = `
    query {
      allCanton(idProvincia: "${provinciaId}") {
        id
        descripcion
      }
    }
  `;

  try{

    const response = await axios.post(rutas.axios + 'api', { query });
    const data = response.data.data.allCanton;

    const dataMap = data.map(item => ({
      value: item.id,
      text: item.descripcion
    }));

    // console.log('cantones', dataMap);
    return dataMap;

  }catch(error){
    console.error('Error en obtener cantones por provincia', error);
    return null;
  }
}


// async fetchParroquias(idcanton) {
//   const query = `
//     query {
//       allParroquia(idcanton: ${idcanton}) {
//         id
//         descripcion
//       }
//     }
//   `;

//   try {
//     const response = await axios.post(rutas.axios + 'api', { query });
//     this.opsParroquias = response.data.data.allParroquia.map(item => ({
//       value: item.id,
//       text: item.descripcion
//     }));
//   } catch (error) {
//     console.error("Error fetching Parroquias:", error);
//   }
// },

// async fetchBarrios(idparroquia) {
//   const query = `
//     query {
//       allBarrio(idparroquia: ${idparroquia}) {
//         id
//         descripcion
//       }
//     }
//   `;
//   try {
//     const response = await axios.post(rutas.axios + 'api', { query });
//     this.opsBarrios = response.data.data.allBarrio.map(item => ({
//       value: item.id,
//       text: item.descripcion
//     }));
//   } catch (error) {
//     console.error("Error fetching Barrios:", error);
//   }
// },



const getProvinciasJson = async () => {

  return Object.entries(dataProvincias).map(([id, provincia]) => ({
    value:id,
    text: provincia.provincia
  }));
}


const getCantonesJson = async (provinciaId) => {
  if (!provinciaId || !dataProvincias[provinciaId]) {
    return [];
  }

  
  const provincia = dataProvincias[provinciaId];
  return Object.entries(provincia.cantones).map(([id, canton]) => ({
    value: id,
    text: canton.canton
  }));
}


const getParroquiasJson = async (cantonId) => {

  const provincia = Object.values(dataProvincias).find(
    prov => Object.prototype.hasOwnProperty.call(prov.cantones, cantonId)
  );

  if (!provincia) return [];
  const parroquias = provincia.cantones[cantonId].parroquias;

  return Object.entries(parroquias).map(([id, nombre]) => ({
    value: id,
    text: nombre
  }));
};


const getUbicacionByParroquia = (parroquiaJsonStr) => {

  let parroquia;

  try {
    parroquia = JSON.parse(parroquiaJsonStr);
  } catch (e) {
    return null;
  }

  const parroquiaId = parroquia.value;

  // Validación mínima
  if (!parroquiaId || parroquiaId.length < 3) {
    return { provincia: null, canton: null, parroquia };
  }

  const cantonId = parroquiaId.slice(0, -2);
  const provinciaId = cantonId.slice(0, -2);

  const provinciaObj = dataProvincias[provinciaId];
  const cantonObj = provinciaObj?.cantones?.[cantonId];

  return {
    provincia : provinciaObj ? { value: provinciaId, text: provinciaObj.provincia } : null,
    canton    : cantonObj ? { value: cantonId, text: cantonObj.canton } : null,
    parroquia : parroquia
  };
};


export const infoPersonasService = {
  getNacionalidades, createNacionalidad,
  getNivelesEducacion,
  getProfesiones, createProfesion,
  getNacionalidadesEtnicas,
  getPueblosKichwa,
  getPaises,
  getProvinciasByPais,
  getCantonesByProvincia,

  getProvinciasJson,
  getCantonesJson,
  getParroquiasJson,
  getUbicacionByParroquia
}